<div class="tw-relative tw-h-full tw-flex tw-flex-col">
  @if(loading){
  <div class="uw-container-overlay tw-flex tw-pt-[25%] tw-justify-center tw-bg-white/40">
    <p-progressSpinner class="tw-absolute  tw-z-50"></p-progressSpinner>
  </div>
  }
  @if(business) {
  <div class="card">
    <h5 class="tw-pb-4">{{ business?.Id ? "Edit" : "New" }} Business</h5>
    <div class="p-fluid p-formgrid">
      <p-tabView #tabview (activeIndexChange)="onTabChange($event)" [activeIndex]="activeIndex">
        @if(canManageBusiness){
        <p-tabPanel header="Admin">
          <div class="tw-max-w-lg">
            <div class="field">
              <label htmlFor="name">Name</label>
              <input pInputText id="name" type="text" [(ngModel)]="business.Name" />
            </div>
            <div class="field">
              <label htmlFor="domain">Domain(s)</label>
              <p-chips id="domain" [(ngModel)]="business.Domains" [addOnBlur]="true"></p-chips>
            </div>
            <div class="field">
              <label htmlFor="service-fee">Service Fee</label>
              <input pInputText id="service-fee" type="number" [(ngModel)]="business.Commission" />
            </div>
            <div class="field">
              <label htmlFor="service-charge">Service Charge</label>
              <input pInputText id="service-charge" type="number" step="0.01" [(ngModel)]="business.OnlinePaymentFee" />
            </div>
            <div class="field">
              <p-checkbox binary="true" label="End-Users Pay Service Fee?" name="user-pay-fee"
                [(ngModel)]="business.UserPayFee"></p-checkbox>
            </div>
            <div class="field flex-row justify-content-between">
              <label htmlFor="testmode">Is in Test Mode?</label>
              <p-inputSwitch name="testmode" [(ngModel)]="business.TestMode"></p-inputSwitch>
            </div>
            <div class="field flex-row justify-content-between">
              <label htmlFor="published">Is Published?</label>
              <p-inputSwitch name="published" [(ngModel)]="business.IsPublished"></p-inputSwitch>
            </div>
            <div class="field flex-row justify-content-between">
              <label htmlFor="extra-services">Extra Services</label>
              <p-multiSelect name="extra-services" [(ngModel)]="business.ExtraServices" [options]="['POS']"
                [showHeader]="false">
              </p-multiSelect>
            </div>
            <div class="field flex-row justify-content-between">
              <label htmlFor="mock">Is Mock?</label>
              <p-inputSwitch name="mock" [(ngModel)]="business.IsMock"></p-inputSwitch>
            </div>
            <div class="field flex-row justify-content-between">
              <label htmlFor="ai">AI Support?</label>
              <p-inputSwitch name="ai" [(ngModel)]="business.AISupport"></p-inputSwitch>
            </div>
            <div class="field">
              <label htmlFor="homepage-categories">Homepage Category / Categories</label>
              <p-multiSelect id="homepage-categories" name="homepage-categories" [(ngModel)]="business.CategoryIds"
                [options]="categoryOptions" optionLabel="label" optionValue="value" [filter]="true"
                placeholder="Select one or more homepage categories">
                <ng-template let-category pTemplate="item">
                  <div class="tw-flex tw-items-center tw-gap-2">
                    @if(category.image){<img [src]="category.image" class="tw-w-8 tw-h-8 tw-object-cover tw-rounded" />}
                    <span>{{ category.label }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
              <small>Categories are defined in System Config → Popular categories as JSON.</small>
            </div>
            <div class="field flex-row justify-content-between">
              <label htmlFor="popular-near-you">Show in Popular Near You?</label>
              <p-inputSwitch name="popular-near-you" [(ngModel)]="business.IsPopularNearYou"></p-inputSwitch>
            </div>
            <div class="field flex-row justify-content-between">
              <label htmlFor="show-phone-business-page">Show phone number on business page?</label>
              <p-inputSwitch name="show-phone-business-page" [(ngModel)]="business.ShowPhoneOnBusinessPage"></p-inputSwitch>
            </div>
            <div class="field flex-row justify-content-between">
              <label htmlFor="show-book-table-business-page">Show Book a table on business page?</label>
              <p-inputSwitch name="show-book-table-business-page" [(ngModel)]="business.ShowBookTableOnBusinessPage"></p-inputSwitch>
            </div>
            <div class="field">
              <label htmlFor="popular-near-you-sort-order">Popular Near You Sort Order</label>
              <input pInputText id="popular-near-you-sort-order" type="number" [(ngModel)]="business.PopularNearYouSortOrder" />
            </div>
            <div class="field flex-row justify-content-between">
              <label htmlFor="is-disabled">Is Disabled?</label>
              <p-inputSwitch name="is-disabled" [(ngModel)]="business.IsDisabled"></p-inputSwitch>
            </div>
          <div class="field">
            <label>Business Postcode</label>
            <input pInputText type="text" [(ngModel)]="business.Postcode" [readonly]="true" />
          </div>
          <div class="field tw-grid tw-grid-cols-2 tw-gap-2">
            <div>
              <label>Latitude</label>
              <input pInputText type="number" [(ngModel)]="business.Latitude" [readonly]="true" />
            </div>
            <div>
              <label>Longitude</label>
              <input pInputText type="number" [(ngModel)]="business.Longitude" [readonly]="true" />
            </div>
          </div>
            <div class="field">
              <label>Business ID</label>
              <p-inputGroup>
                <input pInputText type="text" [ngModel]="business.Id" [readonly]="true" />
                <button pButton type="button" icon="pi pi-copy" (click)="copyToClipboard(business.Id)" pTooltip="Copy Business ID"></button>
              </p-inputGroup>
            </div>
            <div class="field">
              <label htmlFor="connector-api-key">Connector API Key</label>
              <p-inputGroup>
                <input pInputText id="connector-api-key" type="text" [ngModel]="apiKey || '(click Regenerate to generate a key)'" [readonly]="true" />
                <button pButton type="button" icon="pi pi-copy" [disabled]="!apiKey" (click)="copyToClipboard(apiKey)" pTooltip="Copy API Key"></button>
                <button pButton type="button" icon="pi pi-refresh" severity="warning" (click)="resetApiKey()" pTooltip="Regenerate API Key"></button>
              </p-inputGroup>
              <small class="tw-text-orange-500" *ngIf="apiKey">Copy this key now — it will not be shown again after you leave this page.</small>
            </div>
            <div class="field">
              <label>BritLink Android Quick Setup</label>
              <div class="tw-flex tw-flex-col tw-gap-2">
                <button pButton type="button" icon="pi pi-mobile" label="Generate Setup Code" severity="info" (click)="generateSetupCode()" [loading]="setupCodeLoading"></button>
                @if(setupCode) {
                <div class="tw-flex tw-flex-col tw-gap-1 tw-p-3 tw-bg-blue-50 tw-rounded-lg tw-border tw-border-blue-200">
                  <span class="tw-text-sm tw-text-blue-700 tw-font-medium">Enter this code in the BritLink Android app:</span>
                  <div class="tw-flex tw-items-center tw-gap-3">
                    <span class="tw-text-4xl tw-font-bold tw-tracking-widest tw-text-blue-900 tw-font-mono">{{ setupCode }}</span>
                    <button pButton type="button" icon="pi pi-copy" [text]="true" (click)="copyToClipboard(setupCode)" pTooltip="Copy code"></button>
                  </div>
                  <small class="tw-text-blue-600">Valid for 24 hours · Single use · Also resets your API key</small>
                </div>
                }
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Staffs">
          <div class="tw-flex tw-flex-col tw-gap-2">
            <div class="p-fluid p-formgrid grid tw-max-lg" *ngFor="let staff of business.Staffs; let index = index">
              <div class="field col-12 md:col-5">
                <label htmlFor="userid">User</label>
                @if(staff.UserId) {
                <brt-user-avatar [userId]="staff.UserId" [profile]="staff.Profile" />
                } @else {
                <p-autoComplete id="userid" [suggestions]="users" (completeMethod)="searchUser($event.query)"
                  (onSelect)="selectStaff(staff, $event.value)" field="Id">
                  <ng-template let-user pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img [src]="user.Profile.ImageUrl" style="width: 18px" />
                      <div>{{ user.Profile.Name }}</div>
                      <div>
                        [{{
                        user.Identity.Email ||
                        (user.Identity.PhoneNumber | phone)
                        }}]
                      </div>
                    </div>
                  </ng-template>
                </p-autoComplete>
                }
              </div>
              <div class="field col-12 md:col-5">
                <label htmlFor="permissions">Permissions</label>
                <p-listbox [options]="permissions" [(ngModel)]="staff.Permissions" multiple="multiple" [checkbox]="true"
                  [showToggleAll]="false"></p-listbox>
              </div>
              <div class="field col-12 md:col-2 tw-flex tw-flex-row tw-gap-2">
                <p-button icon="pi {{ staff.IsDisabled ? 'pi-eye-slash' : 'pi-eye' }}" [rounded]="true" [text]="true"
                  (click)="staff.IsDisabled = !staff.IsDisabled"></p-button>
                <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
                  (click)="business.Staffs.splice(index, 1)"></p-button>
              </div>
            </div>
            @if(roles?.includes('manage-users')){
            <p-button *ngIf="roles?.includes('manage-users')" class="tw-self-start" label="Add new staff"
              (click)="business.Staffs.push({})"></p-button>
            } @else { * Ask BritEat support team to add new staffs }
          </div>
        </p-tabPanel>
        <p-tabPanel header="Location">
          <div class="field">
            <label htmlFor="business-address">Business Address</label>
            <input pInputText id="business-address" type="text" [(ngModel)]="business.Address"
              placeholder="Shown on the business page when set" />
          </div>
          <brt-location-selector [lines]="3" [(ngModel)]="business.Location"
            [show-title]="false"></brt-location-selector>
          <div class="tw-mt-4">
            <label class="tw-font-semibold tw-block tw-mb-2">Map (OSM)</label>
            <brt-map [lat]="business.Location?.Latitude || 51.505" [lng]="business.Location?.Longitude || -0.09"
              (locationSelected)="onBusinessLocationSelected($event)"></brt-map>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Delivery Zones">
          <div class="field tw-flex tw-flex-col tw-gap-2">
            <div class="field col-12 md:col-6 p-0">
              <label htmlFor="min-order-amount">Min Delivery Order Amount</label>
              <input pInputText id="min-delivery-order-amount" type="number"
                [(ngModel)]="business.MinDeliveryOrderAmount" />
            </div>
            <label>Delivery Zones</label>
            @for(zone of business.DeliveryZones;track $index){
            <p-fieldset [legend]="'Delivery Zone ' + ($index + 1)">
              <div class="p-fluid p-formgrid grid *:tw-py-0">
                <div class="field col-12">
                  <p-button class="tw-self-end" label="Delete this zone" icon="pi pi-trash" severity="danger"
                    (click)="business.DeliveryZones.splice($index, 1)" />
                </div>
                <div class="field col-12 md:col-6">
                  <label htmlFor="postcodes">Postcodes</label>
                  <p-autoComplete id="postcodes" [(ngModel)]="zone.Postcodes" [suggestions]="suggestions"
                    [multiple]="true" (completeMethod)="searchPostcode($event.query)"></p-autoComplete>
                  <!-- <p-button class="tw-self-start" icon="pi pi-map" (click)="showMap(zone)"></p-button> -->
                </div>
                <div class="field col-12 md:col-6">
                  <label htmlFor="distance">Max Distance (mile)</label>
                  <input pInputText id="distance" type="number" [(ngModel)]="zone.MaxDistance" />
                </div>
                <div class="field col-12 md:col-6">
                  <label htmlFor="delivery-fee">Delivery Fee</label>
                  <input pInputText id="delivery-fee" type="number" [(ngModel)]="zone.DeliveryFee" />
                </div>
                <div class="field col-12 md:col-6">
                  <label htmlFor="min-order-amount">Develiry Free if min order amount is</label>
                  <input pInputText id="min-order-amount" type="number" [(ngModel)]="zone.MinOrderAmount" />
                </div>
              </div>
            </p-fieldset>
            }
            <p-button class="tw-self-start" label="Add new zone" (click)="business.DeliveryZones.push({})"></p-button>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Postcode Delivery">
          <div class="field tw-flex tw-flex-col tw-gap-3">
            <small class="tw-text-500">
              Per-postcode overrides for Min Order, Delivery Charge and free-delivery threshold.
              A matching postcode here takes priority over the delivery zones above. Mark a postcode
              as <b>Excluded</b> to refuse delivery there. Import a "Post Codes" Excel file
              (columns: Post Code, Min Order, Delivery Charge, Delivery Free if order over) or edit the rows by hand.
            </small>

            <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
              <p-fileUpload #postcodeUpload mode="basic" chooseLabel="Import Excel" chooseIcon="pi pi-file-excel"
                accept=".xlsx,.xls,.csv" [auto]="true" [customUpload]="true" [maxFileSize]="10000000"
                (uploadHandler)="importPostcodeExcel($event, postcodeUpload)"></p-fileUpload>
              <p-button label="Add postcode" icon="pi pi-plus" severity="secondary" (click)="addPostcodeRule()"></p-button>
              @if(business.PostcodeRules?.length){
              <p-button label="Clear all" icon="pi pi-trash" severity="danger" [text]="true"
                (click)="clearPostcodeRules()"></p-button>
              <span class="tw-text-500 tw-ml-auto">{{business.PostcodeRules.length}} postcode(s)</span>
              }
            </div>

            @if(importingPostcodes){
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-500"><i class="pi pi-spin pi-spinner"></i> Reading Excel…</div>
            }
            @if(postcodeImportSummary){
            <div class="tw-text-green-600">{{postcodeImportSummary}}</div>
            }

            @if(business.PostcodeRules?.length){
            <p-table [value]="business.PostcodeRules" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="480px">
              <ng-template pTemplate="header">
                <tr>
                  <th style="min-width:9rem">Post Code</th>
                  <th style="min-width:8rem">Min Order</th>
                  <th style="min-width:9rem">Delivery Charge</th>
                  <th style="min-width:11rem">Free if order over</th>
                  <th style="min-width:7rem" class="tw-text-center">Excluded</th>
                  <th style="width:4rem"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rule let-i="rowIndex">
                <tr>
                  <td><input pInputText type="text" class="tw-w-full" [(ngModel)]="rule.Postcode" placeholder="e.g. BT53 6AD" /></td>
                  <td><input pInputText type="number" min="0" step="0.01" class="tw-w-full" [(ngModel)]="rule.MinOrderAmount" [disabled]="rule.Excluded" /></td>
                  <td><input pInputText type="number" min="0" step="0.01" class="tw-w-full" [(ngModel)]="rule.DeliveryCharge" [disabled]="rule.Excluded" /></td>
                  <td><input pInputText type="number" min="0" step="0.01" class="tw-w-full" [(ngModel)]="rule.FreeDeliveryOverAmount" [disabled]="rule.Excluded" /></td>
                  <td class="tw-text-center"><p-checkbox [(ngModel)]="rule.Excluded" [binary]="true"></p-checkbox></td>
                  <td class="tw-text-center">
                    <p-button icon="pi pi-trash" severity="danger" [text]="true" (click)="removePostcodeRule(i)"></p-button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
            } @else {
            <div class="tw-text-500 tw-italic">No postcode rules yet. Import an Excel file or add one manually.</div>
            }
          </div>
        </p-tabPanel>
        <p-tabPanel header="Order Settings">
          <div class="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-max-w-lg">
            <div class="field">
              <label>Active Order Types</label>
              <p-multiSelect [options]="orderTypes | slice : 1" [(ngModel)]="business.OrderTypes"></p-multiSelect>
            </div>
            <div class="field">
              <label>Default ETA Minutes</label>
              <div class="p-fluid tw-mt-4">
                <div class="p-formgrid grid tw-py-4 *:tw-py-0"
                  *ngFor="let item of business.DefaultEtaMinutes; let index = index">
                  <div class="field col-12 md:col-4">
                    <label htmlFor="eta-order-type">Order Type</label>
                    @if(item.OrderType === 'Default') {
                    <input pInputText id="eta-order-type" type="text" [ngModel]="item.OrderType" [readonly]="true" />
                    } @else {
                    <p-dropdown [options]="orderTypes | slice : 1" [(ngModel)]="item.OrderType"></p-dropdown>
                    }
                  </div>
                  <div class="field col-12 md:col-4">
                    <label htmlFor="eta-minutes">Minutes</label>
                    <input pInputText id="eta-minutes" type="number" [(ngModel)]="item.Minutes" />
                  </div>
                  <div class="field col-12 md:col-4 tw-justify-end tw-items-end">
                    @if(item.OrderType !== 'Default') {
                    <p-button icon="pi pi-trash" severity="danger"
                      (click)="business.DefaultEtaMinutes.splice(index, 1)"></p-button>
                    }
                  </div>
                </div>
                <p-button class="tw-self-start" label="Add ETA for order type"
                  (click)="business.DefaultEtaMinutes.push({})"></p-button>
              </div>
            </div>
            <div class="field">
              <label htmlFor="print-copies">Print Copies</label>
              <input pInputText id="print-copies" type="number" [(ngModel)]="business.PrintCopies" />
            </div>
            <div class="field">
              <label>Auto Accept</label>
              <p-checkbox id="auto-accept-orders" label="Auto Accept & Print Orders" binary="true"
                [(ngModel)]="business.AutoAcceptOrders"></p-checkbox>
            </div>
            <div class="field">
              <label>Accepted Payment Methods</label>
              <p-multiSelect [options]="paymentMethods" [(ngModel)]="business.PaymentMethods"
                placeholder="Select accepted payment methods"></p-multiSelect>
              <small>Cash and Card are enabled by default. Disable a method to hide it on sales/payment screens.</small>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Extra Fees">
          <div class="field">
            <label>Orders' Extra Fee(s)</label>
            <div class="p-fluid tw-mt-4">
              <div class="p-formgrid grid tw-py-4 *:tw-py-0" *ngFor="let item of business.ExtraFees; let index = index">
                <div class="field col-12 md:col-2">
                  <label htmlFor="type">Order Type</label>
                  <p-dropdown [options]="orderTypes" [(ngModel)]="item.OrderType"></p-dropdown>
                </div>
                <div class="field col-12 md:col-3">
                  <label htmlFor="title">Title</label>
                  <input pInputText id="title" type="text" [(ngModel)]="item.Title" />
                </div>
                <div class="field col-12 md:col-2">
                  <label htmlFor="fee-type">Fee Type</label>
                  <p-dropdown [options]="feeTypes" [(ngModel)]="item.FeeType"></p-dropdown>
                </div>
                <div class="field col-12 md:col-2">
                  <label htmlFor="amount">Amount</label>
                  <input pInputText id="amount" type="number" [(ngModel)]="item.Amount" />
                </div>
                <div class="field col-12 md:col-2">
                  <label htmlFor="min-order-amount">Min Order</label>
                  <input pInputText id="min-order-amount" type="number" [(ngModel)]="item.MinOrderAmount" />
                </div>
                <div class="field col-12 md:col-1 tw-justify-end tw-items-end">
                  <p-button icon="pi pi-trash" severity="danger"
                    (click)="business.ExtraFees.splice(index, 1)"></p-button>
                </div>
                <div class="field col-12">
                  <label htmlFor="fee-categories">Apply to Categories</label>
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <p-checkbox binary="true" inputId="all-categories-{{ index }}"
                      [ngModel]="!item.MenuIds?.length"
                      (ngModelChange)="$event ? (item.MenuIds = []) : null"></p-checkbox>
                    <label htmlFor="all-categories-{{ index }}" class="tw-mb-0">All Categories</label>
                  </div>
                  <p-multiSelect id="fee-categories" [options]="menuCategories" [(ngModel)]="item.MenuIds"
                    optionLabel="Name" optionValue="Id" [filter]="true"
                    placeholder="Select categories (leave empty for all)"
                    [disabled]="!menuCategories.length"></p-multiSelect>
                  <small class="tw-text-gray-500">Leave empty (or tick "All Categories") to apply this fee to the whole
                    order. Otherwise it applies only to items in the selected categories.</small>
                </div>
              </div>
              <p-button class="tw-self-start" label="Add new extra fee"
                (click)="business.ExtraFees.push({})"></p-button>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Credit & Loyalty">
          <div class="tw-max-w-lg">
            <div class="field">
              <label htmlFor="credit-per-new-user">Credit Per New User</label>
              <input pInputText id="credit-per-new-user" type="number" [(ngModel)]="business.CreditPerNewUser" />
            </div>
            <div class="field">
              <label htmlFor="percentage-per-transaction">Percentage Per Order Amount</label>
              <input pInputText id="percentage-per-transaction" type="number"
                [(ngModel)]="business.PercentagePerTransaction" />
            </div>
            <div class="field">
              <label htmlFor="max-credit-per-transaction">Max Usable Credit Per Order</label>
              <input pInputText id="max-credit-per-transaction" type="number"
                [(ngModel)]="business.MaxCreditPerTransaction" />
            </div>

            <hr class="tw-my-4" />

            <div class="field">
              <p-checkbox binary="true" label="Email a promo code for a discount on the next order"
                name="next-order-promo-enabled" [(ngModel)]="business.NextOrderPromoEnabled"></p-checkbox>
            </div>
            <small class="tw-block tw-mb-3 tw-text-gray-500">
              When enabled, after each order the customer is emailed a single-use promo code they can redeem
              at checkout on their next order at this business. The offer is also advertised on the business page.
            </small>

            @if(business.NextOrderPromoEnabled) {
            <div class="field">
              <label htmlFor="next-order-promo-amount">Discount Amount (&pound;)</label>
              <input pInputText id="next-order-promo-amount" type="number" min="0"
                [(ngModel)]="business.NextOrderPromoAmount" />
            </div>
            <div class="field">
              <label htmlFor="next-order-promo-percentage">Discount Percentage (%)</label>
              <input pInputText id="next-order-promo-percentage" type="number" min="0" max="100"
                [(ngModel)]="business.NextOrderPromoPercentage" />
            </div>
            <small class="tw-block tw-mb-3 tw-text-gray-500">
              You can set an amount, a percentage, or both. At least one is required for codes to be issued.
            </small>
            <div class="field">
              <label htmlFor="next-order-promo-min">Minimum Order Amount to Use Code (&pound;)</label>
              <input pInputText id="next-order-promo-min" type="number" min="0"
                [(ngModel)]="business.NextOrderPromoMinOrderAmount" />
            </div>
            <div class="field">
              <label htmlFor="next-order-promo-expiry">Code Valid For (days)</label>
              <input pInputText id="next-order-promo-expiry" type="number" min="1"
                [(ngModel)]="business.NextOrderPromoExpiryDays" />
            </div>
            }
          </div>
        </p-tabPanel>
        <p-tabPanel header="Operating Hours">
          <div class="field col-12 tw-flex tw-flex-col tw-gap-2">
            <label>Operating Hours</label>
            <div class="p-fluid">
              <div class="p-formgrid grid tw-py-4 *:tw-py-0"
                *ngFor="let item of business.OperatingHours; let index = index">
                <div class="field col-12 md:col-2">
                  <label htmlFor="type">Order Type</label>
                  <p-dropdown [options]="orderTypes" [(ngModel)]="item.OrderType"></p-dropdown>
                </div>
                <div class="field col-12 md:col-3">
                  <label htmlFor="day">Days</label>
                  <p-multiSelect [options]="weekDays" [(ngModel)]="item.Days"
                    placeholder="Select days of week"></p-multiSelect>
                </div>
                <div class="field col-12 md:col-3">
                  <label htmlFor="start-time">Start Time</label>
                  <p-inputMask id="start-time" type="text" [(ngModel)]="item.StartTime" mask="99:99:99"
                    placeholder="HH:MM" />
                </div>
                <div class="field col-12 md:col-3">
                  <label htmlFor="end-time">End Time</label>
                  <p-inputMask id="end-time" type="text" [(ngModel)]="item.EndTime" mask="99:99:99"
                    placeholder="HH:MM" />
                </div>
                <div class="field col-12 md:col-1 tw-justify-end tw-items-end">
                  <p-button icon="pi pi-trash" severity="danger"
                    (click)="business.OperatingHours.splice(index, 1)"></p-button>
                </div>
              </div>
              <p-button class="tw-self-start" label="Add new operating time"
                (click)="business.OperatingHours.push({})"></p-button>
            </div>
          </div>

          <div class="field col-12 tw-flex tw-gap-2">
            <label htmlFor="stop-operating-until">
              <i class="pi pi-exclamation-triangle" style="color: red"></i>
              Temporarily Stop Operating Until:
            </label>
            @if(!business.StopOpertingUntil){
            <p-calendar id="stop-operating-until" #StopOpertingUntil [showIcon]="true" [showTime]="true"
              [showOnFocus]="false" [minDate]="now"></p-calendar>
            <button pButton pRipple label="Stop" class="p-button-danger"
              (click)="stopOperatingUntil(StopOpertingUntil.value)"></button>
            } @else {
            <span>{{ business.StopOpertingUntil | date }}</span>
            <button pButton pRipple label="Back Online" class="p-button-success"
              (click)="stopOperatingUntil()"></button>
            }
          </div>
        </p-tabPanel>
        <p-tabPanel header="Bank Account">
          <div class="tw-max-w-lg">
            <div class="field">
              <label htmlFor="account-number">Account Number</label>
              <input pInputText name="account-number" type="text" [(ngModel)]="business.BankAccount.AccountNumber" />
            </div>
            <div class="field">
              <label htmlFor="bank-name">Bank Name</label>
              <input pInputText name="bank-name" type="text" [(ngModel)]="business.BankAccount.BankName" />
            </div>
            <div class="field">
              <label htmlFor="sort-code">Sort Code</label>
              <input pInputText name="sort-code" type="text" [(ngModel)]="business.BankAccount.SortCode" />
            </div>
            <div class="field">
              <label htmlFor="account-type">Account Type</label>
              <p-dropdown name="account-type" [(ngModel)]="business.BankAccount.AccountType"
                [options]="['Indivisual', 'Business']">
              </p-dropdown>
            </div>
            <div class="field">
              <label htmlFor="owner-name">Owner Name</label>
              <input pInputText name="owner-name" type="text" [(ngModel)]="business.BankAccount.OwnerName" />
            </div>
          </div>
        </p-tabPanel>
        }
        <p-tabPanel header="UI Settings">
          <brt-ui-settings id="ui" [(ngModel)]="business.UI" [business-id]="business.Id" [keys]="[
                'Title',
                'Description:text',
                'Slogan',
                'Logo:image',
                'HighlightFeatures',
                'Template:text',
                'ThemeColor',
                'ThemeStyles:text',
                'BackgroundImage:image',
                'HeroImage:image',
                'HeroMediaImage:image',
                'HeroTitle',
                'HeroTitleAccent',
                'HeroSubtitle:text',
                'HeroBadgeText',
                'DeliveryCtaLabel',
                'DeliveryCtaCaption',
                'CollectionCtaLabel',
                'CollectionCtaCaption',
                'BookTableLabel',
                'RatingValue',
                'RatingCount',
                'FoodHygieneRating',
                'ShowLocalBusinessBadge:select:true:false',
                'LocalBusinessCaption',
                'HeroBadges:json',
                'DealCards:json',
                'ShowCategoryStrip:select:true:false',
                'ShowPopularItems:select:true:false',
                'PopularItemsTitle',
                'PopularItemsMax',
                'FullMenuLabel',
                'ShowWhyOrder:select:true:false',
                'WhyOrderTitle',
                'WhyOrderTitleAccent',
                'WhyOrderTitleTail',
                'WhyOrderFeatures:json',
                'ReviewsTitle',
                'Reviews:json',
                'DeliveryAreasTitle',
                'DeliveryAreasCaption',
                'DeliveryAreas:json',
                'DeliveryAreasMapImage:image',
                'ShowRewardsBanner:select:false:true',
                'RewardsTitle',
                'RewardsCaption',
                'RewardsButtonLabel',
                'RewardsImage:image',
                'CarouselItems:json',
                'HomepageHtml:html',
                'StoryHtml:html',
                'AboutHtml:html',
                'ContactHtml:html',
                'AllergenContact',
                'Facebook',
                'Instagram',
                'Twitter',
                'Copyright',
                'Manifest:json'
              ]">
          </brt-ui-settings>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
  <div class="card tw-flex tw-gap-2 tw-p-4 tw-sticky tw-bottom-0 tw-backdrop-blur-md tw-mt-auto">
    <button pButton pRipple label="Save and return to list" (click)="save()"></button>
    <button *ngIf="business.Id" pButton pRipple label="Apply" class="p-button-secondary" (click)="save(false)"></button>
  </div>
  }
</div>

<p-toast></p-toast>

<p-dialog header="Map" [(visible)]="mapVisible" [style]="{ width: '80vw', height: '80vh' }">
  <div class="tw-h-full">@if(mapVisible){<brt-map></brt-map>}</div>
</p-dialog>